/* eslint-disable max-len */
define('LimitItemQuantity.MyAccount.Helper', [
  'LimitItemQuantity.Helper',
  'GlobalViews.Message.View',
  'Configuration'
], function LimitItemQuantityMyAccountHelper(
  Helper,
  GlobalViewsMessageView,
  Configuration
) {
  'use strict';

  return {

    validateAddToCart: function validateAddToCart(view, e, isReorder) {
      var lineId;
      var form;
      var alertPlaceholder;
      var quantity;
      var selectedLine;
      var itemInCart;
      var quantityAvailable;
      var isbackorderable;
      var errorInsufficientAmount = Helper.insufficientAmount;
      var errorMessage;
      var itemValidation;
      var errorMessageItems;
      var isValid = true;
      var validationEnabled = Configuration.get('limitItemQuantity.enabledForOrderHistory');
      if (isReorder) {
        validationEnabled = Configuration.get('limitItemQuantity.enabledForReorderItems');
      }
      if (validationEnabled) {
        lineId = view.$(e.target).data('line-id');
        form = view.$(e.target).closest('[data-type="order-item"]');
        alertPlaceholder = form.find('[data-type=alert-placeholder]');
        quantity = isReorder ? parseInt(form.find('input[name=item_quantity]').val(), 10) : view.$(e.target).data('partial-quantity') || view.$(e.target).data('item-quantity');
        selectedLine = isReorder ? view.collection.get(lineId).get('item') : view.model.get('lines').get(lineId).get('item');
        itemInCart = Helper.findItemInCart(selectedLine);
        quantityAvailable = selectedLine.get('quantityavailable');
        isbackorderable = selectedLine.get('isbackorderable');
        e.preventDefault();

        if (itemInCart) {
          quantity += itemInCart.get('quantity');
        }
        itemValidation = Helper.validateItem({
          quantityavailable: quantityAvailable,
          isbackorderable: isbackorderable
        }, quantity);
        if (!itemValidation.isValid) {
          alertPlaceholder = isReorder ? alertPlaceholder[1] : alertPlaceholder;
          errorMessage = errorInsufficientAmount.errorMessage.replace('[QTY]', quantityAvailable);
          errorMessageItems = new GlobalViewsMessageView({
            message: errorMessage,
            type: 'error',
            closable: true
          });
          view.$(alertPlaceholder).empty().append(errorMessageItems.render().$el.html());
          isValid = false;
        }
      }
      return isValid;
    }
  };
});
